<template>

    <b-form-checkbox
        v-model="form.is_representative"
        name="check-button"
        switch
        :title="switchTitle"
        @change="saveSwitchState"
    />

</template>

<script>
export default {
    name: 'RepresentativeSwitch',

    props: {
        contact: null,
    },

    data() {
        return {
            form: {
                is_representative: false,
            },
            key: '',
        }
    },

    computed: {
        switchTitle() {
            return this.form.is_representative
                ? "Ce contact est mandataire social"
                : "Ce contact n'est pas mandataire social'"
        },
    },

    created() {
        this.form.is_representative = this.contact.is_representative
        this.updateKey()
    },

    methods: {
        async saveSwitchState() {
            try {
                await axios.put(
                    `/clientContacts/${this.contact.id}/physicalPersons/${this.contact.physical_person_id}`,
                    this.form
                )
                this.updateKey()
            } catch (error) {
                console.log(error)
            }
        },

        updateKey() {
            this.key = Date.now()
        },
    },
}
</script>

<style scoped></style>
